/* eslint-disable pii/no-phone-number */
import { Alert, Grid, Box, Typography, Tabs, Tab } from '@mui/material';
import { map } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Checkbox, ContentBox } from '../../components';
import {
  fetchAITdata,
  fetchGetIrregularitiesByPlate,
  fetchGetIrregularityListByIds,
  irregularitiesSlice,
  useDispatch,
  useSelector,
} from '../../stores';
import { palette } from '../../theme';
import { handleApiReturn } from '../../utils';
import { IrregularityCard } from './IrregularityCard';
import { IrregularityDetails } from './IrregularityDetails';
import { IrregularityListDetails } from './IrregularityListDetails';
import { CreateVehicleForIrregularityModal } from './modals/CreateVehicleForIrregularityModal';
import { EditCPFModal } from './modals/EditCPFModal';
import { NewIrregularityPolicyModal } from './modals/NewIrregularityPolicyModal';
import { RegularizeListModal } from './modals/RegularizeListModal';
import { RegularizeModal } from './modals/RegularizeModal';
import { SearchIrregularitiesModal } from './modals/SearchIrregularitiesModal';

export const Irregularities: React.FC = () => {
  const dispatch = useDispatch();
  const { driverId } = useSelector((state) => state.profileReducer);
  const { vehicles } = useSelector((state) => state.vehiclesReducer);
  const { pixLoading } = useSelector((state) => state.pixReducer);
  const {
    irregularityPayablesList,
    irregularityUnpayablesList,
    showDetails,
    showListDetails,
    selectedIds,
    irregularitiesLoading,
    irregularityDetails,
    irregularityPayablesListText,
    irregularityUnpayablesListText,
    irregularityPayablesListNewText,
    irregularityUnpayablesListNewText,
    searchingByCode,
    searchedPlate,
    allIdsSelected,
    allOldIdsSelected,
    allNewIdsSelected,
    AITdata,
  } = useSelector((state) => state.irregularitiesReducer);
  const [value, setValue] = useState(0);

  const currentVehicle = searchedPlate
    ? vehicles.find((v) => v.plate === searchedPlate)
    : (vehicles[0] ?? null);

  useEffect(() => {
    handleResetPage();
  }, []);

  useEffect(() => {
    if (showDetails) {
      if (!irregularityDetails || !irregularityDetails.payment) {
        handleBuggedIrregularities();
      }
    }
  }, [showDetails, showListDetails]);

  const handlePayIrregularities = () => {
    // eslint-disable-next-line lodash/prefer-invoke-map
    const selectedIdsAsString = map(selectedIds, (item) => {
      return item.toString();
    });
    dispatch(
      fetchGetIrregularityListByIds({
        driverId: driverId.toString(),
        irregularityListIds: selectedIdsAsString,
      }),
    ).then((res: any) => {
      if (!res.payload.data.payment) {
        handleBuggedIrregularities();
      } else {
        handleApiReturn(
          res,
          () => {
            dispatch(irregularitiesSlice.actions.toggleShowListDetails());
          },
          null,
        );
      }
    });
  };

  const handleResetPage = () => {
    if (vehicles.length > 0) {
      dispatch(
        fetchGetIrregularitiesByPlate({
          driverId: driverId.toString(),
          plate: searchedPlate || vehicles[0].plate,
        }),
      );
    } else {
      dispatch(irregularitiesSlice.actions.resetSearchedPlate());
    }
    // Don't hide details if we have irregularity details loaded
    if (showDetails && !irregularityDetails) {
      dispatch(irregularitiesSlice.actions.toggleShowDetails());
    }
    showListDetails &&
      dispatch(irregularitiesSlice.actions.toggleShowListDetails());
    dispatch(fetchAITdata());
  };

  const handleBuggedIrregularities = () => {
    dispatch(
      irregularitiesSlice.actions.toggleCreateVehicleForIrregularityIsOpen(),
    );
    toast.warn(
      'Irregularidade sem categoria. Por favor cadastre o veículo relacionado à essa irregularidade para continuar',
    );
    if (showDetails) {
      dispatch(irregularitiesSlice.actions.toggleShowDetails());
    }
  };

  const handleCheck = () => {
    let newSelectedIds: any[] = [];
    if (!allIdsSelected) {
      map(irregularityPayablesList, (item) => {
        newSelectedIds = [...newSelectedIds, item.id];
      });
      dispatch(irregularitiesSlice.actions.setSelectedIds(newSelectedIds));
      dispatch(irregularitiesSlice.actions.setAllIdsSelected(true));
    } else {
      dispatch(irregularitiesSlice.actions.setSelectedIds(newSelectedIds));
      dispatch(irregularitiesSlice.actions.setAllIdsSelected(false));
    }
  };

  // const handleOldCheck = () => {
  //   let newSelectedIds = [...selectedIds]; // current selection from Redux

  //   const allOldSelected = irregularityOldList.every((item) =>
  //     newSelectedIds.includes(item.id),
  //   );

  //   if (allOldSelected) {
  //     // Unselect all from old list
  //     newSelectedIds = newSelectedIds.filter(
  //       (id) => !irregularityOldList.find((item) => item.id === id),
  //     );
  //     dispatch(irregularitiesSlice.actions.setAllOldIdsSelected(false));
  //   } else {
  //     // Add all from old list (only those not already included)
  //     const idsToAdd = irregularityOldList
  //       .map((item) => item.id)
  //       .filter((id) => !newSelectedIds.includes(id));

  //     newSelectedIds = [...newSelectedIds, ...idsToAdd];
  //     dispatch(irregularitiesSlice.actions.setAllOldIdsSelected(true));
  //   }

  //   dispatch(irregularitiesSlice.actions.setSelectedIds(newSelectedIds));
  // };

  // const handleNewCheck = () => {
  //   let newSelectedIds = [...selectedIds]; // from Redux

  //   const allNewSelected = irregularityNewList.every((item) =>
  //     newSelectedIds.includes(item.id),
  //   );

  //   if (allNewSelected) {
  //     // Unselect all from new list
  //     newSelectedIds = newSelectedIds.filter(
  //       (id) => !irregularityNewList.find((item) => item.id === id),
  //     );
  //     dispatch(irregularitiesSlice.actions.setAllNewIdsSelected(false));
  //   } else {
  //     const idsToAdd = irregularityNewList
  //       .map((item) => item.id)
  //       .filter((id) => !newSelectedIds.includes(id));

  //     newSelectedIds = [...newSelectedIds, ...idsToAdd];
  //     dispatch(irregularitiesSlice.actions.setAllNewIdsSelected(true));
  //   }

  //   dispatch(irregularitiesSlice.actions.setSelectedIds(newSelectedIds));
  // };

  function TabPageOne(props: { index: number; value: number }) {
    const { value, index, ...other } = props;
    return (
      <Box
        role='tabpanel'
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        sx={{
          flex: '1 1 0%',
          minHeight: 0,
          width: '100%',
          display: value === index ? 'flex' : 'none',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        {...other}
      >
        {value === index && (
          <Box
            sx={{
              flex: '1 1 0%',
              minHeight: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              padding: '14px',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                width: '100%',
                marginBottom: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 0.5,
              }}
            >
              {irregularityPayablesListNewText && (
                <Alert
                  severity='info'
                  variant='standard'
                  sx={{
                    width: '100%',
                    mb: 0,
                    borderRadius: 1,
                    alignItems: 'center',
                    py: 0.25,
                    '& .MuiAlert-icon': {
                      py: 0,
                      mr: 1,
                    },
                    '& .MuiAlert-message': {
                      py: 0,
                      fontWeight: 600,
                      fontSize: { xs: '0.75rem', sm: '0.8rem' },
                      lineHeight: 1.25,
                      color: palette.primary.main,
                    },
                  }}
                >
                  {irregularityPayablesListNewText}
                </Alert>
              )}
              <Checkbox
                label={
                  <Typography
                    color={palette.text.main}
                    sx={{
                      fontSize: { xs: '13px', sm: '14px' },
                      fontWeight: 600,
                      lineHeight: 1.25,
                    }}
                  >
                    Selecionar todas as irregularidades
                  </Typography>
                }
                checked={allIdsSelected}
                onChange={() => {
                  handleCheck();
                }}
                sx={{
                  padding: '6px 10px',
                  '& .MuiSvgIcon-root': {
                    fontSize: 24,
                  },
                }}
              />
            </Box>
            {irregularityPayablesList.length === 0 ? (
              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={palette.text.main}
                  sx={{
                    fontSize: {
                      xs: '12px',
                      sm: '14px',
                      lg: '18px',
                    },
                  }}
                >
                  Nenhuma irregularidade
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  flex: '1 1 0%',
                  minHeight: 0,
                  width: '100%',
                  height: '100%',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                }}
              >
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                  sx={{
                    width: '100%',
                    minHeight: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignContent: 'flex-start',
                    marginLeft: 0,
                  }}
                >
                  {map(irregularityPayablesList, (item, index) => (
                    <IrregularityCard key={index} item={item} />
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        )}
      </Box>
    );
  }

  function TabPageTwo(props: { index: number; value: number }) {
    const { value, index, ...other } = props;
    return (
      <Box
        role='tabpanel'
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        sx={{
          flex: '1 1 0%',
          minHeight: 0,
          width: '100%',
          display: value === index ? 'flex' : 'none',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        {...other}
      >
        {value === index && (
          <Box
            sx={{
              flex: '1 1 0%',
              minHeight: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              padding: '14px',
              overflow: 'hidden',
            }}
          >
            {irregularityUnpayablesListNewText && (
              <Alert
                severity='warning'
                variant='standard'
                sx={{
                  flexShrink: 0,
                  width: '100%',
                  mb: 2,
                  borderRadius: 1,
                  alignItems: 'center',
                  textAlign: 'left',
                  py: 0.25,
                  '& .MuiAlert-icon': {
                    py: 0,
                    mr: 1,
                  },
                  '& .MuiAlert-message': {
                    py: 0,
                    fontWeight: 600,
                    fontSize: { xs: '0.75rem', sm: '0.8rem' },
                    lineHeight: 1.25,
                  },
                }}
              >
                {irregularityUnpayablesListNewText}
              </Alert>
            )}
            {irregularityUnpayablesList.length === 0 ? (
              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={palette.text.main}
                  sx={{
                    fontSize: {
                      xs: '12px',
                      sm: '14px',
                      lg: '18px',
                    },
                  }}
                >
                  Nenhuma irregularidade
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  flex: '1 1 0%',
                  minHeight: 0,
                  width: '100%',
                  height: '100%',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                }}
              >
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                  sx={{
                    width: '100%',
                    minHeight: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignContent: 'flex-start',
                    marginLeft: 0,
                  }}
                >
                  {map(irregularityUnpayablesList, (item, index) => (
                    <IrregularityCard disabled key={index} item={item} />
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        )}
      </Box>
    );
  }

  const handleCards = () => {
    return (
      <Box
        sx={{
          flex: '1 1 0%',
          minHeight: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Tabs
          value={value}
          onChange={(event: React.SyntheticEvent, newValue: number) => {
            setValue(newValue);
          }}
          variant='fullWidth'
          sx={{
            width: '100%',
            flexShrink: 0,
          }}
        >
          <Tab
            label={irregularityPayablesListText}
            sx={{ flex: 1, width: '100%' }}
          />
          <Tab
            label={irregularityUnpayablesListText}
            sx={{ flex: 1, width: '100%' }}
          />
        </Tabs>
        <TabPageOne value={value} index={0} />
        <TabPageTwo value={value} index={1} />
      </Box>
    );
  };

  return (
    <ContentBox loading={irregularitiesLoading || pixLoading}>
      <Box
        sx={{
          flex: '1 1 0%',
          minHeight: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'stretch',
          overflowY: showDetails || showListDetails ? 'auto' : 'hidden',
          overflowX: 'hidden',
        }}
      >
        {!showDetails && !showListDetails && (
          <Grid
            container
            sx={{
              position: 'relative',
              width: '100%',
              flex: '1 1 0%',
              minHeight: 0,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'stretch',
              gap: 2,
              padding: 2,
            }}
          >
            {/* Vehicle context header */}
            <Box
              sx={{
                width: '100%',
                maxWidth: 920,
                alignSelf: 'center',
                backgroundColor: palette.grey[100],
                padding: { xs: '4px 10px', sm: '6px 14px' },
                borderRadius: '999px',
                textAlign: 'center',
              }}
            >
              {currentVehicle ? (
                <Typography
                  sx={{
                    fontSize: {
                      xs: '13px',
                      sm: '15px',
                      md: '15px',
                      lg: '17px',
                      xl: '23px',
                    },
                    color: palette.primary.main,
                    lineHeight: 1.2,
                  }}
                >
                  {currentVehicle.type} · {currentVehicle.plate}
                </Typography>
              ) : searchedPlate ? (
                <Typography
                  sx={{
                    fontSize: {
                      xs: '13px',
                      sm: '15px',
                      md: '15px',
                      lg: '17px',
                      xl: '23px',
                    },
                    color: palette.primary.main,
                    lineHeight: 1.2,
                  }}
                >
                  Placa: {searchedPlate}
                </Typography>
              ) : (
                <Typography
                  color={palette.text.secondary}
                  sx={{ fontSize: { xs: '12px', sm: '13px' } }}
                >
                  Busque por placa ou selecione um veículo para ver
                  irregularidades
                </Typography>
              )}
            </Box>

            {/* Search and actions */}
            <Grid
              container
              spacing={2}
              sx={{ width: '100%', maxWidth: 920, alignSelf: 'center' }}
            >
              <Grid item xs={12} sm={4}>
                <Button
                  variant='contained'
                  label='Buscar por código'
                  type='submit'
                  size='small'
                  onClick={() => {
                    !searchingByCode &&
                      dispatch(
                        irregularitiesSlice.actions.toggleSearchingByCode(),
                      );
                    dispatch(irregularitiesSlice.actions.toggleSearchIsOpen());
                  }}
                  color='primary'
                  sx={{
                    width: '100%',
                    minHeight: 32,
                    padding: '4px 10px',
                    fontSize: '13px',
                    lineHeight: 1.2,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant='contained'
                  label='Buscar por placa'
                  type='submit'
                  size='small'
                  onClick={() => {
                    searchingByCode &&
                      dispatch(
                        irregularitiesSlice.actions.toggleSearchingByCode(),
                      );
                    dispatch(irregularitiesSlice.actions.toggleSearchIsOpen());
                  }}
                  color='primary'
                  sx={{
                    width: '100%',
                    minHeight: 32,
                    padding: '4px 10px',
                    fontSize: '13px',
                    lineHeight: 1.2,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant='contained'
                  label='Pagar irregularidades selecionadas'
                  type='submit'
                  size='small'
                  onClick={handlePayIrregularities}
                  disabled={selectedIds.length === 0}
                  color='secondary'
                  sx={{
                    width: '100%',
                    minHeight: 32,
                    padding: '4px 10px',
                    fontSize: '13px',
                    lineHeight: 1.2,
                  }}
                />
              </Grid>
            </Grid>

            {/* Results area — tabs fill remaining width/height */}
            <Box
              sx={{
                flex: '1 1 0%',
                minHeight: 0,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  flex: '1 1 0%',
                  minHeight: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '14px',
                  backgroundColor: 'white',
                  boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {handleCards()}
              </Box>
            </Box>
          </Grid>
        )}
        {showDetails && !showListDetails && irregularityDetails?.payment && (
          <IrregularityDetails />
        )}
        {!showDetails && showListDetails && <IrregularityListDetails />}
        <SearchIrregularitiesModal />
        <RegularizeModal />
        <RegularizeListModal />
        <CreateVehicleForIrregularityModal
          resetIrregularities={handleResetPage}
        />
        <EditCPFModal />
        <NewIrregularityPolicyModal />
      </Box>
    </ContentBox>
  );
};
